<template>
  <v-card>
    <v-card-title>
      <span>請求費用詳細</span>
      <br />
    </v-card-title>
    <v-form>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs3>
            <v-text-field :value="importCost" disabled label="輸入コスト" />
          </v-flex>
          <v-flex xs3>
            <v-text-field :value="estimatePrice" disabled label="概算見積" />
          </v-flex>
          <v-flex xs2>
            <v-text-field :value="quotation.containerTypeName" disabled label="コンテナ情報" />
          </v-flex>
          <v-flex xs2>
            <v-text-field
              :disabled="!isFcl"
              :value="quotation.itemContainerQty"
              @change="item=>quotation.actualItemContainerQty=item"
              label="本"
            />
          </v-flex>
          <v-flex xs2>
            <v-text-field
              :disabled="!isCharter"
              :value="quotation.itemCharterTruckQty"
              @change="item=>quotation.actualItemTruckQty=item"
              label=" チャータートラック台数 :"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-card-text>
      <list-summary-charges :shipment="quotation" columns="0,1,2,3,4,10" ignoreSupplier />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['quotation'],
  data() {
    return {}
  },
  methods: {},
  computed: {
    isCharter() {
      return this.quotation.deliveryModelId == 'CHARGE_ITEM_SUB_TYPE-CHARTER'
    },
    isFcl() {
      return this.quotation.stackTypeId == 'STACK_TYPE-FCL'
    },
    importCost() {
      return this.displayItems
        .reduce(
          (x, y) =>
            x +
            (this.quotation.paidType === '無償' && y.isValueCharge
              ? 0
              : y.jpySubTotal),
          0
        )
        .toFixed(2)
    },
    estimatePrice() {
      return this.displayItems
        .filter((i) => i.chargeItemScreenStatistics != '商品代金')
        .filter((i) => i.chargeItemScreenStatistics != '保険費')
        .reduce((x, y) => x + y.jpySubTotal, 0)
        .toFixed(2)
    },
    displayItems() {
      return this.quotation.summaryCharges || []
    },
  },
}
</script>
<style scoped>
.num {
  text-align: right !important;
  padding-right: 8px !important;
}
</style>